import React from 'react'
import s from './PanelBase.module.scss'
import ReadOnlyOperatorsList from './ReadOnlyOperatorsList'
import ReadOnlyDriversList from './ReadOnlyDriversList'
import ReadOnlyBranchesList from './ReadOnlyBranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const TopBasesPanel = ({
  topBasesFilter,
  setTopBasesFilter,
  filteredTopBases,
  topBasesPagination,
  loadTopBasesPage,
  expandedTopBase,
  setExpandedTopBase,
  expandedOperatorsTopBase,
  setExpandedOperatorsTopBase,
  expandedDriversTopBase,
  setExpandedDriversTopBase,
  expandedBranchesTopBase,
  setExpandedBranchesTopBase,
  loadOperatorsByTopBasePage,
  loadDriversByTopBasePage,
  loadBranchesByTopBasePage,
  operatorsByTopBase,
  driversByTopBase,
  branchesByTopBase,
  operatorsPaginationByTopBase,
  driversPaginationByTopBase,
  branchesPaginationByTopBase,
  operatorsFilterByTopBase,
  driversFilterByTopBase,
  branchesFilterByTopBase,
  setOperatorsFilterByTopBase,
  setDriversFilterByTopBase,
  setBranchesFilterByTopBase,
  expandedDriverByTopBase,
  toggleDriver,
  topBases
}) => {
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <h2 className={s.title}>ТОП-Базы</h2>
        {topBasesPagination?.count > 0 && (
          <span className={s.totalBadge}>Всего: {topBasesPagination.count}</span>
        )}
      </div>

      <div className={s.searchRow}>
        <input className={s.searchInput} placeholder="Поиск по базе..." value={topBasesFilter} onChange={(e) => setTopBasesFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadTopBasesPage(1, topBasesFilter) }} />
      </div>

      {filteredTopBases && filteredTopBases.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Название</th>
                <th>Телефон</th>
                <th>Местоположение</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredTopBases.map((tb, index) => (
                <React.Fragment key={tb.id}>
                  <tr>
                    <td className={s.numCell}>{index + 1}</td>
                    <td className={s.nameCell} onClick={() => { const newVal = (expandedTopBase === tb.id ? null : tb.id); setExpandedTopBase(newVal); if (newVal) loadOperatorsByTopBasePage(tb.id, 1); }}>{tb.name}</td>
                    <td>{tb.phone || '—'}</td>
                    <td>
                      {tb.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${tb.geo}`, '_blank')} className={s.geoBtn}>🗺️ Карты</button>
                            <button onClick={() => { const el = document.getElementById(`map-${tb.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none'; }} className={s.mapToggleBtn}>📌</button>
                          </div>
                          <div id={`map-${tb.id}`} style={{ width: 200, height: 150, display: 'none' }}><MiniMap geo={tb.geo} /></div>
                        </div>
                      ) : '—'}
                    </td>
                    <td>
                      <button className={`${s.actionBtn}${expandedBranchesTopBase === tb.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedBranchesTopBase === tb.id ? null : tb.id; setExpandedBranchesTopBase(v); if (v) loadBranchesByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}>Филиалы</button>
                      <button className={`${s.actionBtn}${expandedOperatorsTopBase === tb.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedOperatorsTopBase === tb.id ? null : tb.id; setExpandedOperatorsTopBase(v); if (v) loadOperatorsByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}>Операторы</button>
                      <button className={`${s.actionBtn}${expandedDriversTopBase === tb.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedDriversTopBase === tb.id ? null : tb.id; setExpandedDriversTopBase(v); if (v) loadDriversByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}>Водители</button>
                    </td>
                  </tr>
                  {expandedTopBase === tb.id && (
                    <tr className={s.subRow}>
                      <td colSpan={5}>
                        <div className={s.subContent}>
                          {expandedOperatorsTopBase === tb.id && (
                            <ReadOnlyOperatorsList
                              base={tb}
                              operators={operatorsByTopBase[tb.id]}
                              operatorsFilter={operatorsFilterByTopBase[tb.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadOperatorsPage={loadOperatorsByTopBasePage}
                              operatorsPagination={operatorsPaginationByTopBase[tb.id]}
                              title="Операторы этой ТОП-базы"
                            />
                          )}

                          {expandedDriversTopBase === tb.id && (
                            <ReadOnlyDriversList
                              base={tb}
                              drivers={driversByTopBase[tb.id]}
                              driversFilter={driversFilterByTopBase[tb.id]}
                              setDriversFilter={(v) => setDriversFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadDriversPage={loadDriversByTopBasePage}
                              driversPagination={driversPaginationByTopBase[tb.id]}
                              expandedDriver={expandedDriverByTopBase}
                              toggleDriver={toggleDriver}
                              title="Водители этой ТОП-базы"
                            />
                          )}

                          {expandedBranchesTopBase === tb.id && (
                            <ReadOnlyBranchesList
                              base={tb}
                              baseType="ТОП-базы"
                              branches={branchesByTopBase[tb.id]}
                              branchesFilter={branchesFilterByTopBase[tb.id]}
                              setBranchesFilter={(v) => setBranchesFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadBranchesPage={loadBranchesByTopBasePage}
                              branchesPagination={branchesPaginationByTopBase[tb.id]}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <div className={s.empty}>Список пуст</div>
      )}

      {!topBasesFilter && topBasesPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!topBasesPagination.previous} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) - 1)}>Пред.</button>
          <span>Стр. {topBasesPagination.page || 1} из {Math.ceil(topBasesPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!topBasesPagination.next} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) + 1)}>След.</button>
        </div>
      )}
    </div>
  )
}

export default TopBasesPanel
